import { useState, useEffect } from "react";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

//axios.defaults.baseURL = "http://peachgrove.synology.me:7356/";

interface ErrorType {
  success?: boolean;
  code?: number;
  data?: any;
  message?: string;
  [key: string]: any;
}

export const useApi = (axiosParams: AxiosRequestConfig) => {
  const [response, setResponse] = useState<AxiosResponse>();
  const [error, setError] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");

  const fetchData = async (params: AxiosRequestConfig) => {
    setLoading(true);

    try {
      const result = await axios.request({
        ...params,
        method: params?.method,
        url: `/api/` + params?.url,
        data: params?.data,
      });
      setResponse(result);
    } catch (err: any) {
      console.log(err);

      setError(err.response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (axiosParams) {
      setUrl(axiosParams.url!);
    }
  }, [axiosParams]);

  useEffect(() => {
    if (axiosParams && url !== "" && url !== undefined) {
      fetchData(axiosParams);
    }
  }, [url]);

  return { response, error, loading, fetchData };
};
